<form class="component-container gas-device-container" [formGroup]="gasDeviceFG">
  <div class="ui-g-12 top-border">
    <div class="ui-g-2">
      <label class="ui-g field-label text-right-align">
        {{ ('facilities-data.form-fields.gas-device-label' | translate) + ' ' + (currentIndex + 1) }}
      </label>
    </div>
    <div class="ui-g-9"></div>
    <div
      *ngIf="!isReadOnly && displayDeleteButton"
      class="ui-g-1 pi pi-trash pointer-cursor"
      (click)="deleteComponent.emit(currentIndex)"></div>
  </div>

  <app-custom-fields formControlName="customFields" [applicationSection]="applicationSection" [isReadOnly]="isReadOnly"></app-custom-fields>
</form>
